/* =============================
    CORE ELEMENTS SCRIPTS
   ============================= */

/* -----------------------------
    PREFERRED AGE CATEGORY LOGIC
   ----------------------------- */
function savePreferredAgeCategory() {
  const templateAgeCategory = document.querySelector('meta[property="template:age-category"]').content;

  if (!templateAgeCategory) {
    return;
  }

  localStorage.setItem("melissa.preferred-age-category", templateAgeCategory);
}

document.addEventListener("DOMContentLoaded", savePreferredAgeCategory);

function setHeadersByAgeCategory() {
  const selectors = {
    templateAgeCategoryMeta: "meta[property='template:age-category']",
    header: ".shopify-section--header",
    ageCategoryData: "[data-age-category]"
  };

  const modifiers = {
    hidden: "hidden"
  };

  const defaultAgeCategory = theme.settings.age_categories.melissa;
  const preferredAgeCategory = localStorage.getItem("melissa.preferred-age-category") || defaultAgeCategory;

  const templateAgeCategory = document.querySelector(selectors.templateAgeCategoryMeta).content || preferredAgeCategory;

  const headerElements = Array.from(document.querySelectorAll(selectors.header));

  headerElements.forEach((headerElement) => {
    const ageCategory = headerElement.querySelector(selectors.ageCategoryData).innerText;

    if (ageCategory === templateAgeCategory) {
      headerElement.classList.remove(modifiers.hidden);
    } else {
      if (Shopify.designMode) {
        headerElement.classList.add(modifiers.hidden);
      } else {
        headerElement.remove();
      }
    }
  });
}

document.addEventListener("header:initialized", setHeadersByAgeCategory);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", setHeadersByAgeCategory);
  document.addEventListener("shopify:section:unload", setHeadersByAgeCategory);
  document.addEventListener("shopify:section:reorder", setHeadersByAgeCategory);
}

function setSectionByAgeCategory(sectionSelector) {
  if (!sectionSelector) {
    return;
  }

  const selectors = {
    templateAgeCategoryMeta: "meta[property='template:age-category']"
  };

  const attributes = {
    ageCategory: "data-age-category"
  };

  const modifiers = {
    hidden: "hidden"
  };

  const defaultAgeCategory = theme.settings.age_categories.melissa;
  const preferredAgeCategory = localStorage.getItem("melissa.preferred-age-category") || defaultAgeCategory;

  const templateAgeCategory = document.querySelector(selectors.templateAgeCategoryMeta).content || preferredAgeCategory;

  const sectionElements = Array.from(document.querySelectorAll(sectionSelector));

  sectionElements.forEach((sectionElement) => {
    const ageCategory = sectionElement.getAttribute(attributes.ageCategory);

    if (ageCategory === templateAgeCategory) {
      sectionElement.classList.remove(modifiers.hidden);
    } else {
      if (Shopify.designMode) {
        sectionElement.classList.add(modifiers.hidden);
      } else {
        sectionElement.remove();
      }
    }
  });
}

function setPromoBarByAgeCategory() {
  setSectionByAgeCategory("[data-promo-bar]");
}

setPromoBarByAgeCategory();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", setPromoBarByAgeCategory);
  document.addEventListener("shopify:section:unload", setPromoBarByAgeCategory);
  document.addEventListener("shopify:section:reorder", setPromoBarByAgeCategory);
}

/* -----------------------------
    HEADER SECTION
   ----------------------------- */
class HeaderSection {
  constructor(container) {
    this.container = container;

    this.body = document.querySelector(this.selectors.body);

    this.headerGroupContainer = document.querySelector(this.selectors.headerGroup.container);

    this.mainHeaderBar = this.headerGroupContainer.querySelector(this.selectors.header.main);
    this.ageGroupSwitcher = this.headerGroupContainer.querySelector(this.selectors.ageGroupSwitcher.container);
    this.announcementBarDesktop = this.headerGroupContainer.querySelector(this.selectors.announcementBar.desktop);
    this.announcementBarMobile = this.headerGroupContainer.querySelector(this.selectors.announcementBar.mobile);

    this.cartBubble = this.container.querySelector(this.selectors.cartBubble.container);
    this.cartBubbleText = this.container.querySelector(this.selectors.cartBubble.text);

    this.wrapper = this.container.closest(this.selectors.header.wrapper);
    this.headerAgeCategory = this.wrapper.querySelector(this.selectors.header.ageCategoryData).innerText;

    this.initNavigation();
    this.initStickyHeader();
  }

  get selectors() {
    return {
      body: "body",
      headerGroup: {
        container: "[data-header-group]"
      },
      ageGroupSwitcher: {
        container: "[data-header-age-switcher]"
      },
      announcementBar: {
        desktop: "[data-announcement-bar-desktop]",
        mobile: "[data-announcement-bar-mobile]"
      },
      header: {
        wrapper: ".shopify-section--header",
        main: "[data-header-main]",
        navigation: "[data-header-navigation]",
        ageCategoryData: "[data-age-category]"
      },
      cartBubble: {
        container: "[data-cart-bubble]",
        text: "[data-cart-bubble-text]",
      },
      sidebar: {
        button: {
          open: "[data-header-sidebar-open]",
          close: "[data-header-sidebar-close]"
        },
        switcher: {
          item: "[data-header-sidebar-switcher]"
        }
      }
    }
  }

  get modifiers() {
    return {
      body: {
        scrolled: "scrolled"
      },
      headerGroup: {
        sticky: "header-group--sticky",
        stickyIn: "header-group--sticky-in",
        stickyOut: "header-group--sticky-out"
      },
      cartBubble: {
        full: "header__cart-icon--full",
        textHidden: "header__cart-icon-count--hidden"
      },
      hidden: "hidden"
    }
  }

  get attributes() {
    return {
      sidebar: {
        switcher: {
          ageCategory: "data-header-sidebar-switcher"
        }
      }
    }
  }

  initNavigation() {
    this.addAgeCategoryNavigation();

    document.documentElement.customDelegate(
      "click",
      this.selectors.sidebar.button.open,
      this.openNavigationSidebar.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.sidebar.button.close,
      this.closeNavigationSidebar.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.sidebar.switcher.item,
      this.onNavigationSwitcherClick.bind(this)
    );

    document.documentElement.customDelegate(
      "keydown",
      this.selectors.sidebar.switcher.item,
      (event) => {
        if (event.keyCode === 13) {
          this.onNavigationSwitcherClick(event);
        }
      }
    );
  }

  addAgeCategoryNavigation() {
    const navigationContent = this.wrapper.querySelector("[data-header-sidebar-navigation-wrapper]");

    const otherAgeCategoryNavigationContentSelector = this.headerAgeCategory === theme.settings.age_categories.melissa
      ? `[data-header-sidebar-navigation-wrapper="${theme.settings.age_categories.mini_melissa}"]`
      : `[data-header-sidebar-navigation-wrapper="${theme.settings.age_categories.melissa}"]`;

    const otherAgeCategoryNavigationContent = document.querySelector(otherAgeCategoryNavigationContentSelector).cloneNode(true);
    otherAgeCategoryNavigationContent.classList.add(this.modifiers.hidden);

    navigationContent.parentNode.insertBefore(otherAgeCategoryNavigationContent, navigationContent.nextSibling);
  }

  onNavigationSwitcherClick(event) {
    event.stopImmediatePropagation();

    const target = event.target.closest(this.selectors.sidebar.switcher.item);
    const selectedAgeCategory = target.getAttribute(this.attributes.sidebar.switcher.ageCategory);

    const wrapper = target.closest(this.selectors.header.wrapper);

    wrapper.querySelectorAll("[data-header-sidebar-navigation-wrapper]").forEach(navigationContent => {
      navigationContent.classList.add(this.modifiers.hidden);
    });

    const currentNavigationContent = wrapper.querySelector(`[data-header-sidebar-navigation-wrapper="${selectedAgeCategory}"]`);

    if (currentNavigationContent) {
      currentNavigationContent.classList.remove(this.modifiers.hidden);
    }
  }

  openNavigationSidebar() {
    document.dispatchEvent(new CustomEvent("navigation:open"));
  }

  closeNavigationSidebar() {
    document.dispatchEvent(new CustomEvent("navigation:close"));
  }

  initStickyHeader() {
    this.lastScrollPosition = 0;
    this.delayBeforeStickyHeader = 200;

    this.isMobileBreakpoint = this.checkMobileBreakpoint();

    this.setHeaderHeight();

    window.addEventListener("scroll", this.onScroll.bind(this));
    window.addEventListener("touchmove", this.onScroll.bind(this));

    window.addEventListener("resize", this.onResize.bind(this));

    document.addEventListener("cart:change", this.onCartChange.bind(this));
  }

  onScroll() {
    this.currentScrollPosition = window.scrollY;

    let isHeaderSticky = this.headerGroupContainer.classList.contains(this.modifiers.headerGroup.sticky);

    let topThreshold = this.isMobileBreakpoint
      ? this.ageGroupSwitcherHeight
      : this.announcementBarHeight + this.mainHeaderBarHeight;

    let bottomThreshold = this.headerGroupContainer.offsetHeight;

    if (this.currentScrollPosition <= topThreshold || this.currentScrollPosition <= 0) {
      this.body.classList.remove(this.modifiers.body.scrolled);

      this.headerGroupContainer.classList.remove(this.modifiers.headerGroup.sticky);
      this.headerGroupContainer.classList.remove(this.modifiers.headerGroup.stickyIn);
      this.headerGroupContainer.classList.remove(this.modifiers.headerGroup.stickyOut);

      return false;
    }

    if (this.currentScrollPosition > bottomThreshold && !isHeaderSticky) {
      // Timeout is required for smooth transition between position property changes
      setTimeout(() => {
        this.body.classList.add(this.modifiers.body.scrolled);

        this.headerGroupContainer.classList.add(this.modifiers.headerGroup.sticky);
      }, this.delayBeforeStickyHeader);

      this.headerGroupContainer.classList.add(this.modifiers.headerGroup.stickyOut);
    }

    if (this.currentScrollPosition > this.lastScrollPosition && isHeaderSticky) {
      this.headerGroupContainer.classList.remove(this.modifiers.headerGroup.stickyIn);
      this.headerGroupContainer.classList.add(this.modifiers.headerGroup.stickyOut);
    } else if (this.currentScrollPosition < this.lastScrollPosition && isHeaderSticky) {
      this.headerGroupContainer.classList.remove(this.modifiers.headerGroup.stickyOut);
      this.headerGroupContainer.classList.add(this.modifiers.headerGroup.stickyIn);
    }

    this.setHeaderHeight();

    this.lastScrollPosition = this.currentScrollPosition;
  }

  onResize() {
    this.isMobileBreakpoint = this.checkMobileBreakpoint();

    this.setHeaderHeight();
  }

  onCartChange(event) {
    const cartCount = (event?.detail?.cart?.item_count) || 0;

    if (!cartCount) {
      return false;
    }

    if (!this.cartBubble || !this.cartBubbleText) {
      return;
    }

    this.cartBubble.classList.toggle(this.modifiers.cartBubble.full, !!cartCount);
    this.cartBubbleText.classList.toggle(this.modifiers.cartBubble.textHidden, !cartCount);
  }

  setHeaderHeight() {
    this.headerGroupHeight = this.getElementHeight(this.headerGroupContainer);

    document.documentElement.style.setProperty(
      '--theme-sticky-full-header-height',
      `${this.headerGroupHeight}px`
    );

    this.announcementBarHeight = this.isMobileBreakpoint
      ? this.getElementHeight(this.announcementBarMobile)
      : this.getElementHeight(this.announcementBarDesktop);

    this.mainHeaderBarHeight = this.getElementHeight(this.mainHeaderBar);
    this.ageGroupSwitcherHeight = this.getElementHeight(this.ageGroupSwitcher);

    this.headerGroupOffset = this.isMobileBreakpoint
      ? this.ageGroupSwitcherHeight
      : this.announcementBarHeight + this.mainHeaderBarHeight;

    document.documentElement.style.setProperty(
      '--theme-sticky-header-offset',
      `-${this.headerGroupOffset}px`
    );

    this.stickyHeaderHeight = this.isMobileBreakpoint
      ? this.mainHeaderBarHeight
      : this.headerGroupHeight - this.announcementBarHeight - this.mainHeaderBarHeight;

    document.documentElement.style.setProperty(
      '--theme-sticky-header-height',
      `${this.stickyHeaderHeight}px`
    );
  }

  getElementHeight(element = null) {
    if (!element) {
      return 0;
    }

    return element.getBoundingClientRect().height;
  }

  checkMobileBreakpoint() {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
}

function initHeader() {
  const headerElements = Array.from(document.querySelectorAll("[data-header]"));

  if (!headerElements.length) {
    return;
  }

  headerElements.forEach((headerElement) => new HeaderSection(headerElement));

  document.dispatchEvent(new CustomEvent("header:initialized"));
}

initHeader();

/* -----------------------------
    DESKTOP NAVIGATION
   ----------------------------- */

function positionNavigationDropdowns() {
  const selectors = {
    dropdown: "[data-header-navigation-dropdown]"
  };

  const screenPadding = 20;
  const dropdownOffset = 23;

  const dropdownElements = [...document.querySelectorAll(selectors.dropdown)];

  dropdownElements.forEach((dropdownElement) => {
    const dropdownReferenceElement = dropdownElement.previousElementSibling;

    window.FloatingUIDOM.autoUpdate(dropdownReferenceElement, dropdownElement, () => {
      window.FloatingUIDOM.computePosition(dropdownReferenceElement, dropdownElement, {
        placement: "bottom",
        middleware: [
          window.FloatingUIDOM.offset({
            mainAxis: dropdownOffset
          }),
          window.FloatingUIDOM.flip(),
          window.FloatingUIDOM.shift({
            padding: {
              left: screenPadding,
              right: screenPadding
            }
          })
        ]
      }).then(({x, y}) => {
        dropdownElement.style.setProperty(
          '--dropdown-x-position',
          `${x}px`
        );

        dropdownElement.style.setProperty(
          '--dropdown-y-position',
          `${y}px`
        );
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", positionNavigationDropdowns);

/* -----------------------------
    NAVIGATION COMPONENT
   ----------------------------- */
class NavigationSidebar extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      sidebarContainer: "[data-header-sidebar-container]",
      scrollContent: "[data-header-sidebar-scroll-content]",
      tieredMenu: {
        container: "[data-tiered-menu]",
        trigger: "[data-tiered-menu-trigger]",
        backButton: "[data-tiered-menu-back-button]"
      }
    }
  }

  get modifiers() {
    return {
      sidebar: {
        open: "header-sidebar--open"
      },
      tieredMenu: {
        open: "header-sidebar__menu--tier-open"
      }
    }
  }

  connectedCallback() {
    this.setSidebarHeight();
    this.initTieredMenu();

    this.sidebarScrollContent = this.querySelector(this.selectors.scrollContent);

    document.addEventListener("navigation:open", this.openSidebar.bind(this));
    document.addEventListener("navigation:close", this.closeSidebar.bind(this));

    window.addEventListener("resize", this.onResize.bind(this));
  }

  disconnectedCallback() {
    this.destroyTieredMenu();

    document.removeEventListener("navigation:open", this.openSidebar.bind(this));
    document.removeEventListener("navigation:close", this.closeSidebar.bind(this));

    window.removeEventListener("resize", this.onResize.bind(this));
  }

  openSidebar() {
    this.removeAttribute("inert");

    bodyScrollLock.disableBodyScroll(this.sidebarScrollContent);

    this.classList.add(this.modifiers.sidebar.open);

    const focusableElements = this.getFocusableElements();
    const firstFocusableElement = focusableElements[0];

    setTimeout(() => {
      firstFocusableElement.focus();
    }, 400);

    this.sidebarScrollContent.trapFocus();
  }

  closeSidebar() {
    this.setAttribute("inert", "");

    this.classList.remove(this.modifiers.sidebar.open);

    this.closeAllTieredMenus();

    bodyScrollLock.clearAllBodyScrollLocks();
  }

  initTieredMenu() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        this.openTieredMenu(event);
      }
    });

    document.documentElement.customDelegate(
      "click",
      this.selectors.tieredMenu.trigger,
      this.openTieredMenu.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.tieredMenu.backButton,
      this.closeTieredMenu.bind(this)
    );
  }

  destroyTieredMenu() {
    document.removeEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        this.openTieredMenu(event);
      }
    });

    document.documentElement.removeCustomDelegate(
      "click",
      this.selectors.tieredMenu.trigger,
      this.openTieredMenu.bind(this)
    );

    document.documentElement.removeCustomDelegate(
      "click",
      this.selectors.tieredMenu.backButton,
      this.closeTieredMenu.bind(this)
    );
  }

  openTieredMenu(event) {
    const trigger = event?.target?.closest(this.selectors.tieredMenu.trigger);

    if (!trigger) {
      return false;
    }

    const menu = trigger.nextElementSibling;

    if (!menu) {
      return false;
    }

    bodyScrollLock.disableBodyScroll(menu);

    menu.classList.add(this.modifiers.tieredMenu.open);

    const focusableElements = menu.getFocusableElements();
    const firstFocusableElement = focusableElements[0];

    setTimeout(() => {
      firstFocusableElement.focus();
    }, 400);

    menu.trapFocus();

    menu.removeAttribute("inert");
  }

  closeTieredMenu(event) {
    const backButton = event?.target?.closest(this.selectors.tieredMenu.backButton);

    if (!backButton) {
      return false;
    }

    const menu = backButton.closest(this.selectors.tieredMenu.container);

    if (!menu) {
      return false;
    }

    menu.removeTrapFocus();

    menu.classList.remove(this.modifiers.tieredMenu.open);

    menu.setAttribute("aria-expanded", "false");
    menu.setAttribute("inert", "");

    bodyScrollLock.enableBodyScroll(menu);
  }

  closeAllTieredMenus() {
    const tieredMenus = [
      ...this.querySelectorAll(this.selectors.tieredMenu.container)
    ];

    if (!tieredMenus.length) {
      return false;
    }

    tieredMenus.forEach((tieredMenu) => {
      tieredMenu.classList.remove(this.modifiers.tieredMenu.open);

      tieredMenu.setAttribute("aria-expanded", "false");
      tieredMenu.setAttribute("inert", "");

      bodyScrollLock.enableBodyScroll(tieredMenu);
    });
  }

  setSidebarHeight() {
    const sidebarHeight = window.innerHeight;

    document.documentElement.style.setProperty(
      '--header-sidebar-height',
      `${sidebarHeight}px`
    );
  }

  onResize() {
    this.setSidebarHeight();
  }
}

if (!customElements.get("navigation-sidebar")) {
  customElements.define("navigation-sidebar", NavigationSidebar);
}

/* -----------------------------
    AGE SWITCHER
   ----------------------------- */

class AgeSwitcher extends HTMLElement {
  constructor() {
    super();

    const defaultAgeCategory = theme.settings.age_categories.melissa;
    const preferredAgeCategory = localStorage.getItem("melissa.preferred-age-category") || defaultAgeCategory;

    this.templateAgeCategory = document.querySelector('meta[property="template:age-category"]').content || preferredAgeCategory;
  }

  connectedCallback() {
    const ageSwitcherItems = Array.from(document.querySelectorAll(this.selectors.item));

    ageSwitcherItems.forEach((ageSwitcherItem) => {
      const ageCategory = ageSwitcherItem.getAttribute(this.attributes.item.ageCategory);

      if (ageCategory === this.templateAgeCategory) {
        ageSwitcherItem.classList.add(this.modifiers.item.active);
      } else {
        ageSwitcherItem.classList.remove(this.modifiers.item.active);
      }
    });
  }

  selectors = {
    item: "[data-age-switcher-item]"
  };

  modifiers = {
    item: {
      active: "age-switcher__item--active"
    }
  };

  attributes = {
    item: {
      ageCategory: "data-age-switcher-item-category"
    }
  };
}

if (!customElements.get("age-switcher")) {
  customElements.define("age-switcher", AgeSwitcher);
}

/* -----------------------------
    ACCOUNT NOTIFICATION
   ----------------------------- */

function toggleAccountNotification() {
  const setNotificationStatus = (notificationSeenDateString) => {
    localStorage.setItem("melissa.account-notification-seen-date", notificationSeenDateString);
  };

  const getNotificationStatus = () => {
    return localStorage.getItem("melissa.account-notification-seen-date")
  }

  const clearNotificationStatus = () => {
    localStorage.removeItem("melissa.account-notification-seen-date");
  };

  const showNotification = () => {
    const accountIcon = document.querySelector("[data-account-drawer-open]");
    accountIcon.classList.add("header__circle-icon--pulse");

    setNotificationStatus(new Date().toDateString());
  };

  const lastUpdateDateString = document.querySelector('meta[property="account:last-update-date"]')?.content;

  if (!lastUpdateDateString) {
    clearNotificationStatus();
    return;
  }

  const lastUpdateDate = new Date(lastUpdateDateString);

  const notificationSeenDateString = getNotificationStatus();

  if (notificationSeenDateString) {
    const notificationSeenDate = new Date(notificationSeenDateString);

    if (notificationSeenDate < lastUpdateDate) {
      showNotification();
    }
  } else {
    showNotification();
  }
}

function test() {
  const lastUpdateDateString = document.querySelector('meta[property="account:last-update-date"]')?.content;

  if (!lastUpdateDateString) {
    localStorage.removeItem("melissa.account-notification-seen");
    localStorage.removeItem("melissa.account-notification-seen-date");

    return;
  }

  const lastUpdateDate = new Date(lastUpdateDateString);
  const currentDate = new Date();
  const wasNotificationSeen = localStorage.getItem("melissa.account-notification-seen") === "true";
  const notificationSeenString = localStorage.getItem("melissa.account-notification-seen-date") || lastUpdateDateString;
  const notificationSeenDate = new Date(notificationSeenString);

  if (lastUpdateDate > notificationSeenDate && lastUpdateDate <= currentDate) {
    console.log("New update available, showing notification.");
    // Show the notification logic here

    const todayDateString = currentDate.toDateString();
    localStorage.setItem("melissa.account-notification-seen", "false");
    localStorage.setItem("melissa.account-notification-seen-date", todayDateString);
  } else {
    if (wasNotificationSeen) {
      console.log("Notification was already seen.");
      return;
    }

    const todayDateString = currentDate.toDateString();

    // Check if today is the day to show the notification
    if (notificationSeenDate.toDateString() !== todayDateString) {
      console.log("Notification not seen, updating status.");
      localStorage.setItem("melissa.account-notification-seen", "true");
      localStorage.setItem("melissa.account-notification-seen-date", todayDateString);
    }
  }
}

document.addEventListener("DOMContentLoaded", toggleAccountNotification);

/* -----------------------------
    CUSTOM ZOOM
   ----------------------------- */

if (!customElements.get("zoom-media")) {
  class ZoomMedia extends HTMLElement {
    constructor() {
      super();

      this.onClickListener = this.onClick.bind(this);

      this.onPointerMoveListener = this.onPointerMove.bind(this);
      this.onTouchMoveListener = this.onTouchMove.bind(this);

      this.onKeyDownListener = this.onKeyDown.bind(this);
    }

    static get observedAttributes() {
      return ["zoomed"];
    }

    scale = 1;
    imageElement = null;

    attributes = {
      zoomed: "zoomed"
    };

    get isZoomed() {
      return this.hasAttribute(this.attributes.zoomed);
    }

    get zoomInText() {
      return this.getAttribute("zoom-in-text");
    }

    get zoomOutText() {
      return this.getAttribute("zoom-out-text");
    }

    connectedCallback() {
      document.addEventListener("click", this.onClickListener);

      this.imageElement = this.querySelector("img");

      this.addEventListener("keydown", this.onKeyDownListener);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onClickListener);
      this.removeEventListener("keydown", this.onKeyDownListener);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === this.attributes.zoomed) {
        if (oldValue === null && newValue === "") {
          this.setAttribute("aria-pressed", "true");
          this.setAttribute("aria-label", this.zoomOutText);

          this.dispatchEvent(new CustomEvent("zoom:in", { bubbles: true }));
        } else if (newValue === null) {
          this.setAttribute("aria-pressed", "false");
          this.setAttribute("aria-label", this.zoomInText);

          this.dispatchEvent(new CustomEvent("zoom:out", { bubbles: true }));
        }
      }
    }

    zoomIn() {
      this.addEventListener("pointermove", this.onPointerMoveListener);
      this.addEventListener("touchmove", this.onTouchMoveListener);

      this.scale = 2;
      this.imageElement.style.transform = `translate3d(0, 0, 0) scale(${this.scale})`;

      this.setAttribute(this.attributes.zoomed, "");
    }

    zoomOut() {
      this.removeEventListener("pointermove", this.onPointerMoveListener);
      this.removeEventListener("touchmove", this.onTouchMoveListener);

      this.scale = 1;
      this.imageElement.style.transform = `translate3d(0, 0, 0) scale(${this.scale})`;

      this.removeAttribute(this.attributes.zoomed);
    }

    onClick(event) {
      if (!this.contains(event.target)) {
        this.zoomOut();
        return;
      }

      if (this.isZoomed) {
        this.zoomOut();
      } else {
        this.zoomIn();
      }
    }

    onPointerMove(event) {
      if (!this.isZoomed) {
        return;
      }

      const containerRect = this.imageElement.getBoundingClientRect();

      const x = event.clientX - containerRect.left;
      const y = event.clientY - containerRect.top;

      const offsetX = x / containerRect.width;
      const offsetY = y / containerRect.height;

      this.updateTransformOrigin(offsetX, offsetY);
    }

    onTouchMove(event) {
      if (!this.isZoomed) {
        return;
      }

      event.preventDefault();

      const containerRect = this.imageElement.getBoundingClientRect();
      const touch = event.touches[0];

      const x = touch.clientX - containerRect.left;
      const y = touch.clientY - containerRect.top;

      const offsetX = x / containerRect.width;
      const offsetY = y / containerRect.height;

      const clampedOffsetX = Math.max(0, Math.min(offsetX, 1));
      const clampedOffsetY = Math.max(0, Math.min(offsetY, 1));

      this.updateTransformOrigin(clampedOffsetX, clampedOffsetY);
    }

    onKeyDown(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();

        if (this.isZoomed) {
          this.zoomOut();
        } else {
          this.zoomIn();
        }
      }
    }

    updateTransformOrigin(offsetX, offsetY) {
      this.imageElement.style.transformOrigin = `${offsetX * 100}% ${offsetY * 100}%`;
    }
  }

  customElements.define("zoom-media", ZoomMedia);
}
